// extracted by mini-css-extract-plugin
module.exports = {"icons":"ProdamusPaymentBlockIcons_icons_2sKl1","title":"ProdamusPaymentBlockIcons_title_3rAWr"};